//Dev
// const URL = 'http://localhost:31181/';

//Prod
const URL = 'https://savings-cooperative.thaioilgroup.com/websiteapi/';

//qas
// const URL = 'https://savings-cooperative.thaioilgroup.com/websiteapiqas/';

export default URL;